<template>
  <div>
    <div class="card">
      <div class="left">
        <div class="area" v-for="(item, index) in list" :key="index" @click="selectType(index)">
          <div class="name" :class="{ active: planType === index }">
            {{ item }}
          </div>
        </div>
      </div>

      <div class="right">
        <el-form ref="searchForm1" :model="searchForm" :inline="true" class="global-form">
          <el-form-item prop="areaId">
            <el-select v-model="searchForm.areaId" filterable clearable placeholder="请选择区域名称">
              <el-option :label="item.areaName" :value="item.areaId" v-for="(item, index) of areaList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="planName" v-if="planType === 0">
            <el-input v-model="searchForm.planName" placeholder="请输入计划名称" clearable></el-input>
          </el-form-item>

          <el-form-item prop="deviceNumber" v-if="planType === 1">
            <el-input v-model="searchForm.deviceNumber" placeholder="请输入电磁阀串号" clearable></el-input>
          </el-form-item>
          <el-form-item prop="command" v-if="planType === 1">
            <el-select v-model="searchForm.command" clearable placeholder="请选择操作类型">
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" start-placeholder="开始日期"
              end-placeholder="结束日期" type="daterange" placeholder="请选择日期" @change="dateChange"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <template v-if="planType === 0">
          <el-table class="global-table" v-loading="loading" :data="tableData">
            <el-table-column label="区域名称" show-overflow-tooltip prop="areaName"></el-table-column>
            <el-table-column v-if="planType === 0" label="计划名称" show-overflow-tooltip prop="planName"></el-table-column>
            <el-table-column v-if="planType === 0" label="状态" show-overflow-tooltip prop="areaName"></el-table-column>
            <el-table-column v-if="planType === 0" label="电磁阀数量" show-overflow-tooltip
              prop="valveNum"></el-table-column>
            <el-table-column v-if="planType === 0" label="操作时间" show-overflow-tooltip
              prop="executeTime"></el-table-column>
          </el-table>
          <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
            :page-size.sync="size" :total="total">
          </global-pagination>
        </template>
        <template v-if="planType === 1">
          <el-table class="global-table" v-loading="loading" :data="tableData">
            <el-table-column label="区域名称" show-overflow-tooltip prop="areaName"></el-table-column>
            <el-table-column label="电磁阀串号" show-overflow-tooltip prop="deviceNumber"></el-table-column>
            <el-table-column label="操作类型" show-overflow-tooltip prop="command">
              <template v-slot="{ row }">
                {{ row.command === '0' ? '关闭' : row.command === '1' ? '开启' : '' }}
              </template>
            </el-table-column>
            <el-table-column label="开启时长(分钟)" show-overflow-tooltip prop="execLength"></el-table-column>
            <el-table-column label="操作人" show-overflow-tooltip prop="createUserName"></el-table-column>
            <el-table-column label="操作时间" show-overflow-tooltip prop="ctime"></el-table-column>
          </el-table>
          <global-pagination @size-change="selectIrrigationValveRecordByPage"
            @current-change="selectIrrigationValveRecordByPage" :current-page.sync="page" :page-size.sync="size"
            :total="total">
          </global-pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'IrrigationTimingPlan',
  data () {
    return {

      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      loading: true,
      areaList: [],
      planType: 0,
      dateRange: [],
      list: ['计划执行记录', '手动执行记录'],
      searchForm: {
        startTime: '',
        endTime: '',
        areaId: '',
        deviceNumber: '',
        command: '',
        projectId: ''
      }
    }
  },
  computed: {
    projectId () {
      return this.$route.query.projectId
    }

  },

  created () {
    this.searchForm.projectId = this.projectId
    this.getArea()
    this.loadData()
  },
  methods: {
    getArea () {
      this.$axios.get(this.$apis.irrigation.selectIrrigationAreaByPage, {
        projectId: this.projectId
      }).then((res) => {
        this.areaList = res.list || []
      })
    },

    selectType (index) {
      this.page = 1
      this.planType = index
      if (this.planType === 0) {
        this.loadData()
      } else {
        this.selectIrrigationValveRecordByPage()
      }
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.searchForm.areaId = ''
    },

    dateChange (date) {
      if (date) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },

    onSearch () {
      this.page = 1
      if (this.planType === 0) {
        this.loadData()
      } else {
        this.selectIrrigationValveRecordByPage()
      }
    },

    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.irrigation.selectIrrigationPlanRecordByPage, {
        ...this.searchForm,
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },

    // 手动
    selectIrrigationValveRecordByPage () {
      this.loading = true
      this.$axios.get(this.$apis.irrigation.selectIrrigationValveRecordByPage, {
        ...this.searchForm,
        page: this.page,
        size: this.size,
        commandSource: '1'
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    }
  }

}
</script>

<style scoped lang="scss">
.card {
  display: flex !important;

  .right {
    padding: 20px;
    margin: 0 20px;
    border-left: 1px solid #F4F4F4;
    flex: 1;
  }
}

.left {
  width: 300px;
  min-height: 700px;
  background: #F6F8FB;
  box-shadow: 0px 1px 2px 0px rgba(139, 172, 237, 0.1);
  border-radius: 10px;
  padding: 25px 25px 25px 16px;

  .area {
    display: flex;
    position: relative;
  }

  .name {
    display: flex;
    align-items: center;
    width: 270px;
    height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000517;
    margin-bottom: 10px;
    cursor: pointer;
    padding: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.active,
    &:hover {
      background: var(--color-primary);
      box-shadow: 0px 2px 4px 0px #E5E4FF;
      border-radius: 20px;
      color: #FFFFFF;
    }
  }
}
</style>
